const initialState = {
	count: 0,
	list: [],
	page: 1,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'FAVORITE_MY_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.count = action.payload.count;
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'FAVORITE_MY_LIST_INIT') {
		return initialState;
	}
	else if (action.type === 'FAVORITE_MY_ITEM_SET') {
		let newState = Object.assign({}, state);
		if (action.payload.type === 'del') {
			let index = newState.list.findIndex((v) => v.userdata_id_code === action.payload.pic);
			if (index >= 0) {
				newState.list.splice( index, 1 );
				newState.count = state.count - 1;
			}
		}
		return newState;
	}
	else {
		return state;
	}
}
